import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=3ba6fa55"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"
import style0 from "./Apps.vue?vue&type=style&index=0&id=3ba6fa55&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports